document.addEventListener('DOMContentLoaded', () => {
var instances = new WeakMap();
  var retryTimer = null;

  function clearRetry() {
    if (retryTimer !== null) {
      window.clearInterval(retryTimer);
      retryTimer = null;
    }
  }

  function scheduleRetry() {
    if (retryTimer !== null) return;

    // Swiper 由主题公共脚本异步加载；section 脚本先执行时，用短轮询等待它就绪。
    retryTimer = window.setInterval(function () {
      if (typeof window.Swiper === 'undefined') return;
      clearRetry();
      initAll();
    }, 50);

    window.setTimeout(clearRetry, 5000);
  }

  function initSection(section) {
    if (!section || instances.has(section)) return;

    var swiperEl = section.querySelector('.engraved-page-mousepads__swiper');
    if (!swiperEl) return;

    if (typeof window.Swiper === 'undefined') {
      scheduleRetry();
      return;
    }

    // 轮播项宽度交给 CSS 控制，PC 端五列、M 端 160px 横滑都使用同一个 Swiper 实例。
    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      watchOverflow: true,
      simulateTouch: true,
      passiveListeners: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        prevEl: section.querySelector('.engraved-page-mousepads__nav-button--prev'),
        nextEl: section.querySelector('.engraved-page-mousepads__nav-button--next'),
      },
      pagination: {
        el: section.querySelector('.engraved-page-mousepads__pagination'),
        clickable: true,
      },
    });

    instances.set(section, swiper);
  }

  function destroySection(section) {
    var swiper = instances.get(section);
    if (!swiper) return;

    // 主题编辑器卸载或重载 section 时销毁实例，避免重复初始化导致按钮失效。
    swiper.destroy(true, true);
    instances.delete(section);
  }

  function initAll() {
    document.querySelectorAll('[data-engraved-mousepads]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-engraved-mousepads]')) {
      initSection(event.target.querySelector('[data-engraved-mousepads]'));
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('[data-engraved-mousepads]')) {
      destroySection(event.target.querySelector('[data-engraved-mousepads]'));
    }
  });
});
